import { Component, ElementRef, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../store';
import * as fromProcess from '../../store/process/process.reducer';
import * as fromRemote from '../../store/remote/remote.reducer';
import { Router } from '@angular/router';
import { combineLatest, map } from 'rxjs';

@Component({
  selector: 'app-navigation-error',
  templateUrl: './navigation-error.component.html',
  styleUrls: ['./navigation-error.component.scss'],
})
export class NavigationErrorComponent {
  @ViewChild('errorRef', { static: true }) ref: ElementRef<HTMLDivElement> | undefined;

  position: 'absolute' | 'fixed' = 'absolute';
  processNavigationError$ = this.store.select(fromProcess.selectProcessNavigationError);
  remoteNavigationError$ = this.store.select(fromRemote.selectNavigationError);
  navigationError$ = combineLatest([this.processNavigationError$, this.remoteNavigationError$]).pipe(
    map(([processNavigationError, remoteNavigationError]) => {
      if (this.isRemote) {
        return remoteNavigationError;
      }

      return processNavigationError;
    }),
  );

  isRemote = this.router.url.startsWith('/remote');

  constructor(private store: Store<AppState>, private router: Router) {}

  handleClose(): void {
    this.store.dispatch(fromProcess.actions.resetNavigationError());
  }

  handleOutOfScreen(outOfScreen: boolean): void {
    this.position = outOfScreen ? 'fixed' : 'absolute';
  }
}
